module.exports = __webpack_public_path__ + "img/284.49754db3.png";